import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import TextField from "../../atoms/TextField/TextField";
import DialogActions from "../../molecules/DialogActions/DialogActions";

interface EditDialogProps {
  open: boolean;
  title: string;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  type?: "text" | "password";
  maxLength?: number;
  label?: string;
}

const EditDialog = ({
  open,
  title,
  value,
  onChange,
  onClose,
  onSave,
  type = "text",
  maxLength,
  label,
}: EditDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          value={value}
          onChange={onChange}
          label={label}
          type={type}
          maxLength={maxLength}
          autoFocus
        />
      </DialogContent>
      <DialogActions onCancel={onClose} onConfirm={onSave} />
    </Dialog>
  );
};

export default EditDialog;
